import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import './landing-hero-title.less';

const LandingHeroTitle = ({ text }) => {
  const className = useClassName('LandingHeroTitle');

  return (
    <div className={className('container')}>
      <ContentfulRichText className={className('text')} field={text} />
    </div>
  );
};

LandingHeroTitle.propTypes = {
  text: PropTypes.object.isRequired,
};

export default LandingHeroTitle;
